import {IconButton} from '#/components/buttons/icon-button';
import {ShareLandLogoLink} from '#/components/header/share-land-logo-link';
import {UIStatusContext} from '#/contexts/ui-status-provider';
import {WalletContext} from '#/contexts/wallet-provider';
import {XMarkIcon} from '@heroicons/react/24/outline';
import {LinkIcon} from '@heroicons/react/24/solid';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';

export const SigninWalletToken: FunctionComponent = () => {
  const {web3AuthSignatureResult} = useContext(WalletContext);

  const {setShowSignAppWithWallet} = useContext(UIStatusContext);

  const {t} = useTranslation('translation');

  return (
    <div className='absolute w-full h-full top-0 left-0 z-[70] bg-graybluedark3/70 flex-center px-8 py-16'>
      <div className='w-full h-full max-h-[480px] max-w-[380px] bg-grayblue rounded-xl text-center flex flex-col justify-center gap-4 p-8 items-center relative'>
        <span className='absolute top-2.5 right-3'>
          <IconButton
            IconComponent={XMarkIcon}
            iconClassName='w-5 h-5 fill-white stroke-white'
            onClick={() => {
              setShowSignAppWithWallet(false);
            }}
          />
        </span>

        <div>
          <LinkIcon className='w-16 h-16 stroke-deepblue fill-deepblue' />
        </div>
        <span className='text-white text-xl font-bold'>{t('components.signAppTokenWithWalletOverlay.title')}</span>
        <span className='text-base text-gray-200 font-semibold'>
          {t('components.signAppTokenWithWalletOverlay.description')}
        </span>

        {!!web3AuthSignatureResult.error && (
          <>
            <span className='text-base text-downred font-semibold'>
              {t('components.signAppTokenWithWalletOverlay.error')}
              <br />
              {web3AuthSignatureResult.error
                ? (web3AuthSignatureResult.error as Error).message
                : 'Unknown error occured.'}
            </span>
            <button
              className='hover:opacity-70 align-middle py-1 px-2 overflow-hidden text-white rounded bg-downred relative'
              onClick={() => {
                web3AuthSignatureResult.refetch();
              }}
            >
              {t('actions.retry')}
            </button>
          </>
        )}

        <span className='absolute bottom-3 w-full flex justify-center'>
          <ShareLandLogoLink />
        </span>
      </div>
    </div>
  );
};
